import * as React from 'react';

type LockOptions = {
  lock?: boolean;
  fixed?: boolean;
};

export const useLockBodyScroll = ({ lock, fixed = false }: LockOptions): void => {
  React.useEffect(() => {
    if (!lock) {
      return;
    }

    const { body, documentElement } = document;
    const scrollY = window.scrollY;
    const previousOverflow = body.style.overflow;
    const previousOverscroll = body.style.overscrollBehavior;
    const previousPosition = body.style.position;
    const previousTop = body.style.top;
    const previousLeft = body.style.left;
    const previousWidth = body.style.width;
    const previousRootOverscroll = documentElement.style.overscrollBehavior;

    body.style.overflow = 'hidden';
    body.style.overscrollBehavior = 'none';
    documentElement.style.overscrollBehavior = 'none';

    if (fixed) {
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.left = '0';
      body.style.width = '100%';
    }

    return (): void => {
      body.style.overflow = previousOverflow;
      body.style.overscrollBehavior = previousOverscroll;
      body.style.position = previousPosition;
      body.style.top = previousTop;
      body.style.left = previousLeft;
      body.style.width = previousWidth;
      documentElement.style.overscrollBehavior = previousRootOverscroll;

      if (fixed) {
        window.scrollTo(0, scrollY);
      }
    };
  }, [fixed, lock]);
};

export default useLockBodyScroll;
